import * as React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import Header from './components/Header';
import routes from '../../config/routes';
import Footer from './components/Footer';
import styles from './Layout.module.css';
import DisplayVideo from '../../components/DisplayVideo';
import PatientArticle from 'components/PatientArticle';

interface IProps {
    brandName: string;
    disablePrintMobileOnly: boolean;
}

class DefaultLayout extends React.Component<IProps> {
    render() {
        // Create wrapper components for params
        function PatientArticleWrapper(props: { disablePrintMobileOnly: boolean }) {
            const { mediaKey } = useParams<{ mediaKey: string }>();
            return (
                <PatientArticle
                    mediaKey={mediaKey!}
                    disablePrintMobileOnly={props.disablePrintMobileOnly}
                />
            );
        }

        function DisplayVideoWrapper(props: { disablePrintMobileOnly: boolean }) {
            const { mediaKey } = useParams<{ mediaKey: string }>();
            return (
                <DisplayVideo
                    mediaKey={mediaKey!}
                    disablePrintMobileOnly={props.disablePrintMobileOnly}
                />
            );
        }

        return (
            <div className={styles.app}>
                <div className="app-header">
                    <Header brandName={this.props.brandName} />
                </div>
                <div className="app-body">
                    <div className="main">
                        <Routes>
                            <Route
                                path="/Document/:mediaKey"
                                element={
                                    <PatientArticleWrapper
                                        disablePrintMobileOnly={this.props.disablePrintMobileOnly}
                                    />
                                }
                            />
                            <Route
                                path="/Video/:mediaKey"
                                element={
                                    <DisplayVideoWrapper
                                        disablePrintMobileOnly={this.props.disablePrintMobileOnly}
                                    />
                                }
                            />
                            {routes.map((route, idx) =>
                                route.component ? (
                                    <Route
                                        key={idx}
                                        path={route.path}
                                        element={<route.component />}
                                    />
                                ) : null,
                            )}
                        </Routes>
                    </div>
                </div>
                <div className={styles.appFooter}>
                    <Footer></Footer>
                </div>
            </div>
        );
    }
}

export default DefaultLayout;
